import React from "react"
import { Table as AntTable } from "antd"
import moment from "moment"
import { ExtraButtons } from "src/components/extra-buttons"
import { Header } from "src/components/layout/header"
import { VisibilityProvider } from "src/components/visibility-provider"
import { usePermission } from "src/hooks"
import { CreateSegmentDrawer } from "src/pages-lib/segments/create-drawer"
import api from "src/api"
import styled from "styled-components"

const columns = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    width: 60,
    sorter: (a, b) => a.id - b.id,
    defaultSortOrder: "descend",
  },
  {
    title: "Название",
    dataIndex: "title",
    key: "title",
  },
  {
    title: "Тип",
    dataIndex: "lookupType",
    key: "lookupType",
    width: 100,
    render: (val) => (val === "phone" ? "Телефон" : "GUID"),
  },
  {
    title: "Кол-во",
    dataIndex: "totalCount",
    key: "totalCount",
    width: 80,
  },
  {
    title: "Файл",
    dataIndex: "fileName",
    key: "fileName",
    width: 200,
  },
  {
    title: "Дата создания",
    dataIndex: "createdAt",
    key: "createdAt",
    width: 160,
    render: (val) => (val ? moment(val).format("DD.MM.YYYY HH:mm") : "—"),
  },
]

export default function Segments() {
  const { hasPermission } = usePermission()
  const [createDrawerState, setCreateDrawerState] = React.useState(false)
  const [items, setItems] = React.useState([])
  const [isLoading, setIsLoading] = React.useState(false)
  const [pagination, setPagination] = React.useState(null)

  React.useEffect(() => {
    loadItems()
  }, [])

  async function loadItems(page = 1, pageSize = 20) {
    setIsLoading(true)
    try {
      const { data } = await api.get(
        `segments?page=${page}&pageSize=${pageSize}`,
        { useMailingApi: true }
      )
      setItems(data.items ?? [])
      setPagination({
        current: data.pagination.page,
        pageSize: data.pagination.pageSize,
        total: data.pagination.total,
      })
    } catch (error) {
      console.error("Ошибка загрузки сегментов", error)
    } finally {
      setIsLoading(false)
    }
  }

  function onCreated() {
    setCreateDrawerState(false)
    loadItems()
  }

  return (
    <>
      <Header
        title="Сегменты"
        extra={
          <ExtraButtons
            onCreate={
              hasPermission("segments.create")
                ? () => setCreateDrawerState(true)
                : undefined
            }
            titles={{ onCreate: "Новый сегмент" }}
          />
        }
      />

      <StyledTable
        dataSource={items.map((i) => ({ ...i, key: i.id }))}
        columns={columns}
        loading={isLoading}
        pagination={pagination}
        onChange={(pag) => loadItems(pag.current, pag.pageSize)}
        size="small"
      />

      <VisibilityProvider visible={createDrawerState}>
        <CreateSegmentDrawer
          onClose={() => setCreateDrawerState(false)}
          onSuccess={onCreated}
        />
      </VisibilityProvider>
    </>
  )
}

const StyledTable = styled(AntTable)``
